// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__xl4uU"};